import { FC } from "react";
import { useTranslation } from "react-i18next";
import CurrencyIconSVG from "../../resources/svg/CurrencyIconSVG";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectPlatformInfo } from "../../../slices/platform-info-slice";
import { selectWorksStatisticYear } from "../../../slices/works-statistic-slice";

const MarketRatesSection: FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const currentYear = new Date().getFullYear();

    const platformInfo = useSelector(selectPlatformInfo);
    const statistic = useSelector(selectWorksStatisticYear);

    const redirectCallback = (city: string) => {
        return () => navigate(`/catalog?city=${city.split(" ").at(0)}`);
    };

    return (
        <div className="relative flex flex-col items-center mx-auto dmin2:w-[1280px] di6:w-[800px] ti6:w-[650px] ti7:w-[560px] tmax4:w-[360px] py-[100px] dmax2:py-[60px]">
            <h1 className="H32B dmax2:H24B text-textWhite text-center w-full mb-10 dmax2:mb-6">
                {t("main.partTimeJobValueTitle", { currentYear: currentYear })}
            </h1>
            <div className="flex flex-col gap-2 dmax2:gap-1 w-full max-w-[846px]">
                {statistic.map((item) => (
                    <div
                        key={item.name}
                        onClick={redirectCallback(item.name)}
                        className="flex justify-between items-center h-[72px] dmax5:h-[52px] border border-backgroundButton bg-[rgba(255,255,255,0.05)] hover:bg-[rgba(255,255,255,0.1)] transition duration-300 rounded-[10px] px-8 dmax2:px-[15px] cursor-pointer"
                    >
                        <span className="H24B di6:H20B ti9:H14B tmax4:H12B text-textWhite">{item.name}</span>
                        <div className="flex items-center h-10 dmax5:h-7 bg-primaryBlue rounded-[30px] px-4 dmax2:px-[10px]">
                            <CurrencyIconSVG className="w-6 dmax2:w-4 h-6 dmax2:h-4 text-textWhite mr-3 dmax2:mr-1.5" />
                            <span className="H16 dmax5:H10 text-textWhite">
                                {t("main.jobPricesTitle", { min: item.min, max: item.max })}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
            {platformInfo.worksPerHour ? (
                <p className="H20 dmax2:H14 text-textFaded mt-10 dmax2:mt-6">
                    {t("main.worksPerHourTitle", { worksPerHour: platformInfo.worksPerHour })}
                </p>
            ) : (
                <></>
            )}
            <Link
                to="/catalog"
                className="button H16B dmax2:H14B text-textWhite h-[50px] dmax2:h-10 px-6 dmax2:px-4 mt-6 dmax2:mt-4 transition duration-300"
            >
                {t("main.partTimeJobButton")}
            </Link>
        </div>
    );
};

export default MarketRatesSection;
